import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";

async function getLinkDetailsRequest(id: string) {
	return await apiClient.get(API.QUERY.LINK.DETAILS, { params: { id } }).then((res) => res.data);
}

export function useGetLinkDetailsRequest(id: string) {
	return useQuery<{ name: string }, AxiosError>({
		queryKey: ["link", "details", id],
		queryFn: () => getLinkDetailsRequest(id)
	});
}
